module.exports = __webpack_public_path__ + "img/zero_new.80a96547.png";